import api from "./api";

export interface HospitalRegistrationPayload {
  hospital: {
    hospitalName: string;
    domainName: string;
    officialEmail: string;
    officialPhone?: string;
    addressline1?: string;
    addressline2?: string;
    city?: string;
    country?: string;
    postcode?: string;
    subscriptionPlanId?: string;
  };
  admin: {
    name: string;
    email: string;
    // password: string;
    // confirmPassword: string;
    /** Optional – when omitted, backend generates a temporary password and sends it via welcome email */
    password?: string;
    confirmPassword?: string;
  };
}

export interface VerifyOtpPayload {
  adminEmail: string;
  otp: string;
}

export interface ApiResponse<T = any> {
  success: boolean;
  message: string;
  data?: T;
}

export const registerHospital = async (
  payload: HospitalRegistrationPayload
): Promise<ApiResponse> => {
  try {
    const { data } = await api.post("/platform/hospitals/register",payload);

    return data;
  } catch (error: any) {
    if (error.response?.data) {
      throw error.response.data;
    }

    throw {
      success: false,
      message: "Unable to connect to server",
    };
  }
};


export const registerHospitalRequest = async (
  payload: HospitalRegistrationPayload
) => {
  const response = await api.post(
    "/platform/register-request",
    payload
  );

  return response.data;
};

/**
 * Verify OTP and complete hospital registration
 */
export const verifyHospitalRegistrationOtp = async (
  payload: VerifyOtpPayload
) => {
  const response = await api.post(
    "/platform/verify-otp",
    payload
  );

  return response.data;
};


export const checkDomainAvailability = async (domain: string) => {
  const response = await api.get(
    `/platform/check-domain`,
    {
      params: { domain },
    }
  );
  return response.data as { available: boolean };
};

export const checkHospitalNameExistence = async (name: string) => {
  const response = await api.get(
    `/platform/check-hospital-name`,
    {
      params: { name },
    }
  );
  return response.data as { available: boolean };
};
